import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './components/Home';
import Header from './components/Header';
import About from './components/About';
import Works from './components/Works';
import Contact from './components/Contact';

function App() {
  const [isSmallScreen, setScreen] = useState(
    window.innerWidth < 768 || window.innerWidth < window.innerHeight
  );
  const [windowHeight, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    setScreen(
      window.innerWidth < 768 || window.innerWidth < window.innerHeight
    );
  }, []);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setScreen(window.innerWidth < 768);
      setHeight(window.innerHeight);
    });

    return () => {
      window.removeEventListener('resize', () => {});
    };
  }, [isSmallScreen]);

  return (
    <Router>
      <div className='relative'>
        <Header />
        <Switch>
          <Route exact path='/'>
            <Home isSmallScreen={isSmallScreen} windowHeight={windowHeight} />
          </Route>
          <Route path='/about'>
            <About windowHeight={windowHeight} />
          </Route>
          <Route path='/works'>
            <Works windowHeight={windowHeight} />
          </Route>
          <Route path='/contact'>
            <Contact windowHeight={windowHeight} />
          </Route>
          <Route>
            <Home isSmallScreen={isSmallScreen} windowHeight={windowHeight} />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
